import { render, staticRenderFns } from "./facebookLiveInfoCapture.vue?vue&type=template&id=e03f867a&"
import script from "./facebookLiveInfoCapture.vue?vue&type=script&lang=js&"
export * from "./facebookLiveInfoCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports